import script from "./DoctorHeaderSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./DoctorHeaderSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./DoctorHeaderSkeleton.vue?vue&type=style&index=0&id=8a01c618&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a01c618"]])

export default __exports__